import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  steps: [],
};

export const DeliveryStepsSlice = createSlice({
  name: "DeliveryStepsSlice",
  initialState,
  reducers: {
    SetDeliverySteps: (state, action) => {
      state.steps = action.payload;
    },
  },
});

export const { SetDeliverySteps } = DeliveryStepsSlice.actions;
export default DeliveryStepsSlice.reducer;
